import { UserResponse } from "@responses/UserResponse"
import { useEffect, useState } from "react"

type UserRequest = {
    user: UserResponse,
    requested_at: string
}

function AdminPage() {

    const [userRequest, setUserRequest] = useState<UserRequest[]>()

    useEffect(() => {
        setUserRequest([
            {
                user: {
                    id: '1',
                    username: "Ian Eddy"
                },
                requested_at: (new Date()).toLocaleString()
            },
            {
                user: {
                    id: '2',
                    username: "John Doe"
                },
                requested_at: (new Date()).toLocaleString()
            },
            {
                user: {
                    id: '3',
                    username: "Mr. Frogs"
                },
                requested_at: (new Date()).toLocaleString()
            },
            {
                user: {
                    id: '4',
                    username: "Snowy Foxy"
                },
                requested_at: (new Date()).toLocaleString()
            },
        ])
    }, [])

    return (
        <>
            <div className="w-full h-full absolute z-10 overflow-x-clip">
                <div className="rounded-full absolute top-0 left-0 bg-blue blur-xl animate-blob" style={{ opacity: .5, width: "40rem", height: "40rem" }}></div>
                <div className="rounded-full absolute top-[60%] right-0 bg-green blur-xl animate-blob" style={{ opacity: .5, animationDelay: "1s", width: "40rem", height: "40rem" }}></div>
            </div>
            <main className="relative py-24 px-8 lg:px-12 z-10 flex flex-col justify-center text-white font-display">
                <header className="flex flex-row justify-end items-center gap-4 mb-4">
                    <p className="text-xl">admin_username</p>
                    <img src="/src/img/avatars/admin.png" alt="profile_picture" className="rounded-full w-10 h-10" />
                </header>
                
                <section className="flex flex-col lg:flex-row w-full min-h-screen gap-6">
                    <div className="w-full lg:w-1/3 gap-6 grid grid-cols-2 lg:flex flex-col lg:pr-6">
                        <div className="w-full flex flex-col lg:grid grid-cols-2 lg:gap-2 items-center p-4 bg-[#1B2372] rounded-xl">
                            <p className="font-black text-center text-[3rem] lg:text-[5rem] inline leading-none text-[#8DD059]">10K</p>
                            <p className="text-lg lg:text-2xl font-body pl-2 text-center lg:text-left">Verified user</p>
                        </div>
                        <div className="w-full flex flex-col lg:grid grid-cols-2 lg:gap-2 items-center p-4 bg-[#1B2372] rounded-xl">
                            <p className="font-black text-center text-[3rem] lg:text-[5rem] inline leading-none text-[#737EF2]">90K</p>
                            <p className="text-lg lg:text-2xl font-body pl-2 text-center lg:text-left">Unverified user</p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-4 h-full w-full lg:w-2/3">
                        <p className="text-2xl">User Verification</p>
                        <div className="flex flex-col rounded-t-xl bg-[#737EF2] bg-opacity-[0.35]">
                            <div className="grid grid-cols-4 gap-4 p-4 w-full bg-[#606CE0] bg-opacity-60 rounded-t-xl">
                                <span>User</span>
                                <span className="col-span-2">Requested At</span>
                                <span>Action</span>
                            </div>
                            <div className="w-full h-full overflow-y-scroll no-scrollbar">
                                {
                                    userRequest?.map((user) => (
                                        <div className="grid grid-cols-4 gap-4 p-4 w-full border border-[#606CE0] border-opacity-60 font-body items-center">
                                            <span>{user.user.username}</span>
                                            <span className="col-span-2">{user.requested_at}</span>
                                            <div className="lg:flex flex-row flex-wrap gap-2 hidden">
                                                <button
                                                    type="button"
                                                    className="bg-[#737EF2] rounded-full px-3 py-2"
                                                >
                                                    Approve
                                                </button>
                                                <button
                                                    type="button"
                                                    className="border border-[#737EF2] rounded-full px-3 py-2"
                                                >
                                                    Reject
                                                </button>
                                            </div>
                                            <div className="lg:hidden flex-row flex-wrap gap-2 flex">
                                                <button
                                                    type="button"
                                                    className="bg-[#737EF2] rounded-full p-2"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="border border-[#737EF2] rounded-full p-2"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                                </button>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}

export default AdminPage